import React, { lazy } from 'react';
const ebooks = [{
  title: 'Libro-Caja Compulsión Alimentaria',
  border: 'border-primary/20',
  tag: 'Mente',
  image: 'https://cdn.magicpatterns.com/uploads/5ZsnX4tf1dmfyVpoVbeTHX/20260408_2046_Compulsion_Alimentaria_simple_compose_01knqqss1fe09syans3hrws1p3.png'
}, {
  title: 'Baraja de las Heridas Emocionales Femeninas',
  border: 'border-accent/20',
  tag: 'Conducta',
  image: 'https://cdn.magicpatterns.com/uploads/gCcBX5sXwNVqSoBdYWu5Vw/20260408_1752_Image_Generation_simple_compose_01knqdv74reasa978tbn4v54s9.png'
}, {
  title: 'Descubrí lo que Cada Síntoma Físico Revela',
  border: 'border-bonus/20',
  tag: 'Cuerpo',
  image: 'https://cdn.magicpatterns.com/uploads/8N7uGKLxcsVBq2UZBvTu7B/20260408_2042_Image_Generation_simple_compose_01knqqhwtjfj3as1t0vh2bryqy.png'
}];
export function EbookShowcase() {
  return <section className="w-full px-4 py-6 md:py-10 bg-white" data-id="element-33">
      <div className="max-w-4xl mx-auto space-y-4" data-id="element-34">
        <div className="text-center space-y-2" data-id="element-35">
          <div className="inline-flex items-center gap-2 bg-accent/10 text-accent font-bold px-3 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-36">
            <span data-id="element-37">3 ebooks</span>
            <span className="w-1 h-1 bg-accent rounded-full" data-id="element-38"></span>
            <span data-id="element-39">al precio de 1</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main" data-id="element-40">
            Esto es lo que recibís hoy
          </h2>
        </div>

        <div className="grid grid-cols-3 gap-3" data-id="element-41">
          {ebooks.map((ebook, index) => <div key={index} className={`relative bg-white rounded-lg border ${ebook.border} shadow-sm overflow-hidden`} data-id="element-42">
              <div className="relative w-full aspect-[2/3] overflow-hidden" data-id="element-43">
                <img src={ebook.image} alt={ebook.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover" data-id="element-44" />
                <div className="absolute top-1.5 right-1.5 bg-white/90 text-[9px] font-bold text-text-main px-1.5 py-0.5 rounded-full shadow-sm z-10 uppercase tracking-wider" data-id="element-45">
                  {ebook.tag}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}